// @material-ui/core components
import { makeStyles } from "tss-react/mui";

// core components
import Image from "next/image.js";
import Link from "next/link.js";
import Button from "../CustomButtons/Button.js";

// sections for this page
import ForumsSearchBar from "../ForumsSearchBar/ForumsSearchBar.js";

// local assets
import bannerRightImgBg from "../../public/img/forums/bannerRightImgBg.png";
import bannerRightImgDecor from "../../public/img/forums/bannerRightImgDecor.png";

import styles from "../../styles/jss/nextjs-material-kit/pages/forumsStyle.js";
import {buildSlug} from "../../util/url";

const useStyles = makeStyles()(styles);

export default function ForumsBanner(props) {
    const { classes, cx } = useStyles();
    const data = props.data;

    return (
        <>
            <div className={classes.forumsBanner}>
                <div className={cx(classes.forumsBannerContainer + " " + classes.container)}>
                    <div className={classes.forumsBannerLeft}>
                        <h1 className={classes.forumsBannerTitle}>{data?.category?.name} Community</h1>
                        <p className={classes.forumsBannerDescription}>{data?.category?.description}</p>
                        <ForumsSearchBar data={data?.category} />
                    </div>
                    {!!data?.category?.image && <>
                        <div className={classes.forumsBannerRight}>
                            <Image className={classes.bannerRightImageBg} src={bannerRightImgBg} alt={"banner-image-bg"} fill={true} />
                            <div className={classes.bannerRightImageFrame}>
                                <Image className={classes.bannerRightImage} src={data?.category?.image} alt={"banner-image"} fill={true} />
                            </div>
                            <Image className={classes.bannerRightImageDecor} src={bannerRightImgDecor} alt={"banner-image-decor"} fill={true} />
                        </div>
                    </>}
                </div>
            </div>
            {data?.subCategories?.length > 0 && data.topicCount > 0 &&
                <div className={classes.bannerLower}>
                    <div className={cx(classes.bannerSubCategories + " " + classes.container)}>
                    <p className={cx(classes.bannerSubCategoryText + " " + classes.bannerSubCategoryTitle)}>Choose a sub-community</p>
                    <div className={classes.bannerSubCategoriesContainer}>
                        {data.subCategories.map((category, index) => {
                            return (
                                <Button className={classes.bannerSubCategory} key={index}>
                                    <Link href={`/community/${buildSlug(category.name)}-${category.subCatId}`} className={classes.bannerSubCategoryLink}>
                                        <p className={classes.bannerSubCategoryText} >{category.name}</p>
                                    </Link>
                                </Button>
                            )
                        })}
                    </div>
                    </div>
                </div>
            }
        </>

    )
}
